import type { CSSProperties } from 'react'

export function formatRiskRatingDisplay(data: {
  risk_rating?: string | null
  risk_rating_error?: string | null
}): string {
  const rating = data.risk_rating != null ? String(data.risk_rating).trim() : ''
  if (rating !== '') {
    return rating
  }
  const error = data.risk_rating_error != null ? String(data.risk_rating_error).trim() : ''
  if (error !== '') {
    return error
  }
  return 'Pending'
}

export function riskRatingBadgeStyle(color?: string | null): CSSProperties | undefined {
  if (color == null || String(color).trim() === '') {
    return undefined
  }
  return {
    backgroundColor: color,
  }
}
